import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="w-full bg-background-900 text-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <a href="/" className="inline-flex items-center gap-2 no-underline mb-4">
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                Vigorbuy<span className="text-primary-400">Spread</span>
              </span>
            </a>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              The most comprehensive Vigorbuy spreadsheet resource center — helping shoppers discover, compare, and purchase products with confidence since 2026.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer no-underline">
                <i className="ri-global-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="/" className="text-sm text-background-400 hover:text-background-50 transition-colors no-underline">
                  Home
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-50 transition-colors no-underline">
                  Vigorbuy Spreadsheet
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-50 transition-colors no-underline">
                  Buy It Now
                </a>
              </li>
              <li>
                <Link to="/article/vigorbuy-spreadsheet-complete-guide" className="text-sm text-background-400 hover:text-background-50 transition-colors no-underline">
                  Complete Guide
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">Popular Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-50 transition-colors no-underline whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">More Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(6).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-50 transition-colors no-underline whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
              <li>
                <Link to="/article/vigorbuy-spreadsheet-complete-guide" className="text-sm text-background-400 hover:text-background-50 transition-colors no-underline">
                  SEO Guide
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 Vigorbuy Spreadsheet Resource Center. All rights reserved.
          </p>
          <p className="text-xs text-background-500">
            External links open in new tabs with{" "}
            <code className="bg-background-800 px-1.5 py-0.5 rounded text-xs">rel="noopener nofollow"</code>
          </p>
        </div>
      </div>
    </footer>
  );
}